<template>
  <div class="payment">
    <v-card max-width="1000" class="mx-auto" elevation="0">
      <v-subheader>Payment Information</v-subheader>
      <v-card flat>
        <v-container v-if="payment">
          <v-simple-table>
            <tr>
              <th>Shipping Address</th>
              <td>{{ payment.shipping_address }}</td>
            </tr>
            <tr>
              <th>Invoice Number</th>
              <td>{{ payment.invoice_number }}</td>
            </tr>
            <tr>
              <th>Total Bill</th>
              <td>Rp. {{ payment.total_bill.toLocaleString("id-ID") }}</td>
            </tr>
          </v-simple-table>
        </v-container>
      </v-card>

      <v-subheader></v-subheader>

      <v-layout row wrap>
        <v-flex xs12 text-center>
          <v-btn color="success" @click="finish" elevation="24" x-large> Finish </v-btn>
        </v-flex>
      </v-layout>
    </v-card>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
export default {
  computed: {
    ...mapGetters({
      payment: "payment",
    }),
  },
  created() {
    if (this.payment == undefined) {
      this.setAlert({
        status: true,
        text: "Payment undefined",
        color: "warning",
      });
      this.$router.push("/");
    }
  },
  methods: {
    ...mapActions({
      setAlert: "alert/set",
    }),
    finish() {
      this.setAlert({
        status: true,
        text: "Transaction done",
        color: "success",
      });
      this.$router.push("/");
    },
  },
  data() {
    return {
      dialog: false,
    };
  },
};
</script>
